import { AlphaOBoxOutlineIcon } from './AlphaOBoxOutlineIcon';

/**
 * author: Contributors
 * id 9563FB80-4D77-4800-B7DF-CCFDD00A49DD
 * name alpha-o-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterOBoxOutlineIcon = AlphaOBoxOutlineIcon;
export default LetterOBoxOutlineIcon